import { render } from "./DisplayField.vue?vue&type=template&id=03428480&scoped=true&ts=true"
import script from "./DisplayField.vue?vue&type=script&lang=ts"
export * from "./DisplayField.vue?vue&type=script&lang=ts"

import "./DisplayField.vue?vue&type=style&index=0&id=03428480&scoped=true&lang=css"

import exportComponent from "/builds/entersekt/repos/sdk-browser/saas-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03428480"]])

export default __exports__